// React dependencies
import React, { useEffect, useState } from 'react';

// External dependencies
import { Dialog, DialogContent, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';

// Internal dependencies
import Colours from '../../../styles/colours';
import MText from '../../common/MText';
import Icons from '../../common/Icons';
import MButton from '../../common/MButton';
import { IsEmpty } from '../../../common/checks';
import MapLocationSelect from './MapLocationSelect';

const useStyles = makeStyles(() => ({
  dialogPaper: {
    '@media (max-width:600px)': {
      width:    '100vw !important',
      maxWidth: '100vw !important',
      margin:   0,
    },
    borderRadius: '20px !important',
  },
  closeIcon: {
    position: 'absolute',
    width:    16,
    height:   16,
    right:    16,
    top:      16,
    cursor:   'pointer',
    zIndex:   2,
  },
}));

const PickPoiLocationModal = (props) => {
  const [existingMarker, setExistingMarker] = useState(null);
  const classes = useStyles();

  useEffect(() => {
    setExistingMarker(props.existingMarker);
  }, [props.existingMarker]);

  const handleClose = () => props.onClose();

  const onLocationChange = (newPosition) => {
    try {
      let markerData = null;
      if (!IsEmpty(newPosition)) {
        setExistingMarker();
        markerData = {
          lat: newPosition.lat,
          lng: newPosition.lng,
        };
      }
      setExistingMarker(markerData);
      props.onLocationChange(markerData);
    } catch (error) {
      toast.error(error.message);
    }
  };

  return (
    <Dialog
      open={props.open}
      onClose={handleClose}
      fullWidth
      maxWidth="md"
      classes={{ paper: classes.dialogPaper }}
    >
      <DialogContent className="px-3 d-flex flex-column pt-0 pb-4" style={{ overflow: 'scroll' }}>

        <div className="position-absolute" style={{ top: 10, right: '1rem' }}>
          <MButton
            variant="text"
            style={{ width: '2.2rem', height: '2.2rem' }}
            icon={() => <Icons.Cross fontSize="1rem" />}
            onClick={props.onClose}
          />
        </div>

        <div className="mt-4 d-flex justify-content-center">
          <MText
            text="Select location on map"
            semibold
            colour={Colours.LightBlue2}
            size={15}
          />
        </div>

        <div className="w-100 mt-2 mb-1" style={{ height: '70dvh' }}>
          <MapLocationSelect
            GOOGLE_MAP_API_KEY={props.GOOGLE_MAP_API_KEY}
            height="68dvh"
            currentCoord={existingMarker}
            markerIcon={props.markerIcon}
            mapCenterCoord={props.mapCenterCoord}
            staticMarkerIcon={props.staticMarkerIcon}
            staticMarkersData={props.staticMarkersData || []}
            onChange={onLocationChange}
          />
        </div>

        <div className="mt-2 d-flex flex-row justify-content-center pb-3">
          <MButton
            className="px-5"
            text="Done"
            textMedium
            textSize={14}
            onClick={props.onClose}
            variant="outlined"
            style={{ borderRadius: 30, borderColor: Colours.Black }}
          />
        </div>

      </DialogContent>
    </Dialog>
  );
};

PickPoiLocationModal.defaultProps = {
  center:            null,
  existingMarker:    null,
  markerIcon:        () => {},
  mapCenterCoord:    null,
  staticMarkerIcon:  () => {},
  staticMarkersData: [],
};

PickPoiLocationModal.propTypes = {
  open:               PropTypes.bool.isRequired,
  onClose:            PropTypes.func.isRequired,
  GOOGLE_MAP_API_KEY: PropTypes.string.isRequired,
  center:             PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number,
  }),
  existingMarker: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number,
  }),
  onLocationChange: PropTypes.func.isRequired,

  mapCenterCoord: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number,
  }),
  markerIcon:        PropTypes.func,
  staticMarkerIcon:  PropTypes.func,
  staticMarkersData: PropTypes.arrayOf(PropTypes.shape({})),
};

export default PickPoiLocationModal;
